// extracted by mini-css-extract-plugin
module.exports = {"publisher-box":"publisher-box","publisher-item":"publisher-item"};